import { logout } from './authenticationService'
import axios from 'axios'
import { COMMON_ERROR_MESSAGE } from '../constants/messages'
import { isUUID } from '../helpers'

export const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms))

export const isProduction = () => {
  const activeEnv =
    process.env.GATSBY_ACTIVE_ENV || process.env.NODE_ENV || 'development'
  return activeEnv === 'production'
}

export function authHeader(accessToken) {
  if (accessToken) {
    return {
      Authorization: 'Bearer ' + accessToken,
      'Ocp-Apim-Subscription-Key': process.env.REACT_APP_APIM_KEY,
    }
  } else {
    let user = JSON.parse(localStorage.getItem('mmsgUser'))
    if (user && user.token) {
      return {
        Authorization: 'Bearer ' + user.token,
        'Ocp-Apim-Subscription-Key': process.env.REACT_APP_APIM_KEY,
      }
    } else {
      return { 'Ocp-Apim-Subscription-Key': process.env.REACT_APP_APIM_KEY }
    }
  }
}

export async function query(url, options = {}, accessToken) {
  try {
    const { headers, body, ...others } = options
    const fetchOptions = {
      url,
      data: body,
      headers: {
        ...authHeader(accessToken),
        ...headers,
      },
      ...others,
    }
    const response = await axios(fetchOptions)
    return response.data
  } catch (error) {
    let errMsg = ''
    if (error.response) {
      // Request made and server responded
      if (error.response.status === 401) {
        // auto logout if 401 response returned from api
        logout()
        if (!window.location.pathname.startsWith('/login')) {
          var cookieObjArray = document.cookie.split('=')
          var oppId = ''
          if (
            cookieObjArray !== null &&
            cookieObjArray !== undefined &&
            cookieObjArray.length > 2
          ) {
            if (isUUID(cookieObjArray[3])) {
              oppId = cookieObjArray[3]
            }
          }
          window.location.href = '/login?oppId=' + oppId
        }
      }
      errMsg =
        error.response.data && error.response.data.message
          ? `${error.response.data.message}`
          : error.message
      if (error.response.data.statusCode !== 422) {
        errMsg = COMMON_ERROR_MESSAGE
      }
    } else {
      // Something happened in setting up the request that triggered an Error
      errMsg = COMMON_ERROR_MESSAGE
    }

    error.message = errMsg
    return Promise.reject(errMsg)
  }
}

export const fakeCall = (mockResult, callback) =>
  wait(2000).then(() => {
    if (callback) callback()
    return mockResult
  })

export const saveUser = (user) =>
  window.localStorage.setItem('mmsgUser', JSON.stringify(user))
